export default class WordFeedback {

  constructor() {
    /** @type {boolean} */
    this.pronounced = false;
    /** @type {boolean} */
    this.syllabified = false;
  }

}



// WEBPACK FOOTER //
// ./src/model/data/wordFeedback.js